import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaArrowLeft,
  FaChevronDown,
  FaMobileAlt,
  FaCheckCircle,
  FaClock,
  FaWallet,
  FaMoneyBillWave,
  FaShieldAlt,
  FaCoins,
  FaExchangeAlt,
  FaBitcoin,
  FaSearch,
  FaTimes,
} from "react-icons/fa";

import "./DepisitBFCOrder.css";


export default function DepositBFCOrder() {

  const navigate = useNavigate();


  /* =====================================================
     LIMITS
  ===================================================== */

  const MAX_AMOUNT = 5000000;


  /* =====================================================
     COUNTRIES
     MOBILE MONEY ONLY
  ===================================================== */

  const countries = [

    {
      name: "Tanzania",
      flag: "🇹🇿",
      currency: "TZS",
      rate: 2660,
      minAmount: 10000,
    },

    {
      name: "Kenya",
      flag: "🇰🇪",
      currency: "KES",
      rate: 129.5,
      minAmount: 1000,
    },

    {
      name: "Uganda",
      flag: "🇺🇬",
      currency: "UGX",
      rate: 3725,
      minAmount: 10000,
    },

    {
      name: "Rwanda",
      flag: "🇷🇼",
      currency: "RWF",
      rate: 1415,
      minAmount: 5000,
    },

    {
      name: "Burundi",
      flag: "🇧🇮",
      currency: "BIF",
      rate: 2920,
      minAmount: 10000,
    },

    {
      name: "DR Congo",
      flag: "🇨🇩",
      currency: "CDF",
      rate: 2895,
      minAmount: 10000,
    },

    {
      name: "Zambia",
      flag: "🇿🇲",
      currency: "ZMW",
      rate: 25.7,
      minAmount: 100,
    },

    {
      name: "Botswana",
      flag: "🇧🇼",
      currency: "BWP",
      rate: 13.7,
      minAmount: 50,
    },

    {
      name: "Madagascar",
      flag: "🇲🇬",
      currency: "MGA",
      rate: 4550,
      minAmount: 10000,
    },

    {
      name: "Malawi",
      flag: "🇲🇼",
      currency: "MWK",
      rate: 1745,
      minAmount: 10000,
    },

    {
      name: "Mozambique",
      flag: "🇲🇿",
      currency: "MZN",
      rate: 64,
      minAmount: 100,
    },

    {
      name: "South Sudan",
      flag: "🇸🇸",
      currency: "SSP",
      rate: 5200,
      minAmount: 10000,
    },

    {
      name: "Zimbabwe",
      flag: "🇿🇼",
      currency: "USD",
      rate: 1,
      minAmount: 10,
    },

  ];


  /* =====================================================
     MOBILE MONEY METHODS
  ===================================================== */

  const countryMobileMethods = {

    Tanzania: [
      "Vodacom (M-Pesa)",
      "Airtel Money",
      "Yas (Tigo Pesa)",
      "Halotel Money",
    ],

    Kenya: [
      "Safaricom",
      "Airtel Money",
    ],

    Uganda: [
      "MTN",
      "Airtel",
    ],

    Rwanda: [
      "MTN",
      "Airtel",
    ],

    Burundi: [
      "Ecocash",
      "Lumicash",
    ],

    "DR Congo": [
      "Vodacom M-Pesa",
      "Airtel",
      "Orange",
      "Illico Cash",
    ],

    Zambia: [
      "Airtel",
      "MTN",
      "Zamtel",
    ],

    Malawi: [
      "Airtel",
      "TNM",
    ],

    Mozambique: [
      "Vodacom",
    ],

    Zimbabwe: [
      "EcoCash",
    ],

    "South Sudan": [
      "MGurush",
      "MTN",
    ],

    Botswana: [
      "Orange",
      "BTC",
      "Mascom",
    ],

    Madagascar: [
      "Airtel",
      "Orange",
    ],

  };


  /* =====================================================
     STATE
  ===================================================== */

  const [message, setMessage] =
    useState("");


  const [amount, setAmount] =
    useState("");


  const [selectedCountry, setSelectedCountry] =
    useState(null);


  const [showCountry, setShowCountry] =
    useState(false);


  const [countrySearch, setCountrySearch] =
    useState("");


  const [depositMethod, setDepositMethod] =
    useState("mobile");


  const [provider, setProvider] =
    useState("");


  const [showProviders, setShowProviders] =
    useState(false);


  const [showHint, setShowHint] =
    useState(false);


  /* =====================================================
     COUNTRY DATA
  ===================================================== */

  const exchangeRate =
    selectedCountry
      ? Number(
          selectedCountry.rate
        ) || 0
      : 0;


  const minimumAmount =
    selectedCountry
      ? Number(
          selectedCountry.minAmount
        ) || 0
      : 0;


  const currency =
    selectedCountry?.currency ||
    "";


  const mobileMethods =
    selectedCountry
      ? (
          countryMobileMethods[
            selectedCountry.name
          ] || []
        )
      : [];


  /* =====================================================
     FILTER COUNTRIES
  ===================================================== */

  const filteredCountries =
    countries.filter(
      (country) => {

        const search =
          countrySearch
            .trim()
            .toLowerCase();


        if (!search) {
          return true;
        }


        return (

          country.name
            .toLowerCase()
            .includes(search)

          ||

          country.currency
            .toLowerCase()
            .includes(search)

        );

      }
    );


  /* =====================================================
     SHOW MESSAGE
  ===================================================== */

  const showBanner = (
    text
  ) => {

    setMessage(text);


    setTimeout(() => {

      setMessage("");

    }, 3000);

  };


  /* =====================================================
     OPEN COUNTRY SELECTOR
  ===================================================== */

  const openCountrySelector = () => {

    if (
      depositMethod !==
      "mobile"
    ) {

      return;

    }


    setShowCountry(true);

    setCountrySearch("");

    setShowProviders(false);

    setShowHint(false);

  };


  /* =====================================================
     CLOSE COUNTRY SELECTOR
  ===================================================== */

  const closeCountrySelector = () => {

    setShowCountry(false);

    setCountrySearch("");

  };


  /* =====================================================
     SELECT COUNTRY
  ===================================================== */

  const handleCountrySelect = (
    country
  ) => {

    setSelectedCountry(
      country
    );


    /* Reset amount */

    setAmount("");


    /* Reset provider */

    setProvider("");


    /* Close provider */

    setShowProviders(
      false
    );


    /* Reset hint */

    setShowHint(false);


    /* Close modal */

    setShowCountry(
      false
    );


    /* Clear search */

    setCountrySearch("");


    /* Clear message */

    setMessage("");

  };


  /* =====================================================
     AMOUNT CHANGE
  ===================================================== */

  const handleAmountChange = (
    e
  ) => {

    const value =
      e.target.value;


    if (
      value === ""
    ) {

      setAmount("");

      return;

    }


    const cleanValue =
      value.replace(
        /\D/g,
        ""
      );


    const normalizedValue =
      cleanValue.replace(
        /^0+(?=\d)/,
        ""
      );


    setAmount(
      normalizedValue
    );

  };


  /* =====================================================
     DEPOSIT METHOD CHANGE
  ===================================================== */

  const handleDepositMethodChange = (
    method
  ) => {

    /* ===================================================
       MOBILE MONEY
    =================================================== */

    if (
      method ===
      "mobile"
    ) {

      setDepositMethod(
        "mobile"
      );

      setShowProviders(
        false
      );

      setShowHint(
        false
      );

      return;

    }


    /* ===================================================
       USDT / CRYPTO
       
       DIRECT NAVIGATION
       
       No country
       No amount
       No provider
       No network
       No exchange rate
    =================================================== */

    if (
      method ===
      "crypto"
    ) {

      navigate(
        "/BfcMobilePaymentcrypto",
        {
          state: {

            crypto:
              "USDT",

            depositMethod:
              "crypto",

            receiveCurrency:
              "USDT",

            type:
              "deposit",

          },

        }
      );


      return;

    }

  };


  /* =====================================================
     SELECT PROVIDER
  ===================================================== */

  const selectProvider = (
    item
  ) => {

    setProvider(
      item
    );


    setShowProviders(
      false
    );


    setShowHint(
      false
    );

  };


  /* =====================================================
     NUMERIC AMOUNT
  ===================================================== */

  const numericAmount =
    Number(
      amount || 0
    );


  /* =====================================================
     MOBILE USDT
  ===================================================== */

  const mobileUsdtAmount =
    numericAmount > 0 &&
    exchangeRate > 0

      ? numericAmount /
        exchangeRate

      : 0;


  /* =====================================================
     FORMATTING
  ===================================================== */

  const formattedAmount =
    numericAmount > 0

      ? numericAmount.toLocaleString(
          "en-US"
        )

      : "0";


  const formattedMobileUsdt =
    mobileUsdtAmount > 0

      ? mobileUsdtAmount.toFixed(
          2
        )

      : "0.00";


  /* =====================================================
     HANDLE MOBILE DEPOSIT
  ===================================================== */

  const handleDeposit = () => {

    const depositAmount =
      Number(
        amount
      );


    /* ===================================================
       COUNTRY
    =================================================== */

    if (
      !selectedCountry
    ) {

      showBanner(
        "Please select country"
      );


      setShowCountry(
        true
      );


      return;

    }


    /* ===================================================
       AMOUNT
    =================================================== */

    if (
      !amount
    ) {

      showBanner(
        `Please enter amount in ${currency}`
      );


      return;

    }


    /* ===================================================
       VALID NUMBER
    =================================================== */

    if (
      !Number.isFinite(
        depositAmount
      )
    ) {

      showBanner(
        "Please enter a valid amount"
      );


      return;

    }


    /* ===================================================
       MINIMUM
    =================================================== */

    if (
      depositAmount <
      minimumAmount
    ) {

      showBanner(
        `Minimum deposit amount is ${minimumAmount.toLocaleString(
          "en-US"
        )} ${currency}`
      );


      return;

    }


    /* ===================================================
       MAXIMUM
    =================================================== */

    if (
      depositAmount >
      MAX_AMOUNT
    ) {

      showBanner(
        `Maximum deposit amount is ${MAX_AMOUNT.toLocaleString(
          "en-US"
        )} ${currency}`
      );


      return;

    }


    /* ===================================================
       PROVIDER
    =================================================== */

    if (
      !provider
    ) {

      setShowHint(
        true
      );


      setShowProviders(
        true
      );


      setTimeout(() => {

        setShowHint(
          false
        );

      }, 3000);


      return;

    }


    /* ===================================================
       PREPARE DEPOSIT DATA
    =================================================== */

    const calculatedReceiveAmount =
      Number(
        mobileUsdtAmount.toFixed(
          2
        )
      );


    /* ===================================================
       GO TO MOBILE PAYMENT
    =================================================== */

    navigate(
      "/bfc-mobile-payment",
      {
        state: {

          /* =============================================
             AMOUNT
          ============================================= */

          amount:
            depositAmount,


          /* =============================================
             USDT
          ============================================= */

          usdtAmount:
            calculatedReceiveAmount,


          receiveAmount:
            calculatedReceiveAmount,


          receiveCurrency:
            "USDT",


          /* =============================================
             RATE
          ============================================= */

          rate:
            exchangeRate,


          exchangeRate:
            exchangeRate,


          /* =============================================
             COUNTRY
          ============================================= */

          country:
            selectedCountry,


          countryName:
            selectedCountry.name,


          flag:
            selectedCountry.flag,


          currency:
            selectedCountry.currency,


          minimumAmount:
            minimumAmount,


          /* =============================================
             PROVIDER
          ============================================= */

          provider:
            provider,


          paymentMethod:
            provider,


          /* =============================================
             METHOD
          ============================================= */

          depositMethod:
            "mobile",


          type:
            "deposit",

        },

      }
    );

  };


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div
      className="bfc-deposit-page"
    >


      {/* =================================================
          MESSAGE
      ================================================= */}

      {message && (

        <div
          className="bfc-banner-message"
        >

          {message}

        </div>

      )}


      {/* =================================================
          HEADER
      ================================================= */}

      <div
        className="bfc-deposit-header"
      >


        <button
          type="button"
          className="bfc-back-button"
          onClick={() =>
            navigate(-1)
          }
          aria-label="Go back"
        >

          <FaArrowLeft />

        </button>


        <div
          className="bfc-header-title"
        >

          <span
            className="bfc-header-badge"
          >

            BFC WALLET

          </span>


          <h2>
            Deposit BFC
          </h2>


          <p>
            Add funds using Mobile Money
            or Crypto
          </p>

        </div>


        <div
          className="bfc-header-security"
        >

          <FaShieldAlt />

        </div>

      </div>


      {/* =================================================
          DEPOSIT / WITHDRAW
      ================================================= */}

      <div
        className="bfc-buy-sell"
      >

        <button
          type="button"
          className="active"
        >

          Deposit

        </button>


        <button
    type="button"
    onClick={() => navigate("/withdraw")}
  >
    Withdraw
  </button>


      </div>


      {/* =================================================
          COUNTRY SELECTOR
      ================================================= */}

      <div
        className={`bfc-country-selector-box ${
          !selectedCountry
            ? "country-not-selected"
            : ""
        }`}
        onClick={
          openCountrySelector
        }
      >

        <div
          className="bfc-country-selector-left"
        >

          <div
            className="bfc-country-flag"
          >

            {selectedCountry
              ? selectedCountry.flag
              : "🌍"}

          </div>


          <div
            className="bfc-country-details"
          >

            <span>
              DEPOSIT COUNTRY
            </span>


            <strong>

              {selectedCountry
                ? selectedCountry.name
                : "Select Country"}

            </strong>


            <small>

              {selectedCountry

                ? `${currency} • 1 USDT = ${exchangeRate.toLocaleString(
                    "en-US"
                  )} ${currency}`

                : "Choose your deposit country"}

            </small>

          </div>

        </div>


        <FaChevronDown />

      </div>


      {/* =================================================
          PAYMENT METHOD
      ================================================= */}

      <div
        className="bfc-input-box"
      >


        <div
          className="bfc-input-label-row"
        >

          <label>
            DEPOSIT METHOD
          </label>

          <span>
            PAYMENT
          </span>

        </div>


        <div
          className="bfc-deposit-method-selector"
        >


          {/* =============================================
              MOBILE MONEY
          ============================================= */}

          <button
            type="button"
            className={
              depositMethod ===
              "mobile"
                ? "active"
                : ""
            }
            onClick={() =>
              handleDepositMethodChange(
                "mobile"
              )
            }
          >

            <FaMobileAlt />

            <span>
              Mobile Money
            </span>

          </button>


          {/* =============================================
              CRYPTO
          ============================================= */}

          <button
            type="button"
            className="crypto-direct-button"
            onClick={() =>
              handleDepositMethodChange(
                "crypto"
              )
            }
          >

            <FaBitcoin />

            <span>
              USDT / Crypto
            </span>

          </button>

        </div>


        {/* =================================================
            AMOUNT LABEL
        ================================================= */}

        <div
          className="bfc-input-label-row"
          style={{
            marginTop:
              "12px",
          }}
        >

          <label>
            ENTER DEPOSIT AMOUNT
          </label>


          <span>
            {currency || "---"}
          </span>

        </div>


        {/* =================================================
            AMOUNT
        ================================================= */}

        <div
          className="bfc-amount-row"
        >

          <div
            className="bfc-money-icon"
          >

            <FaMoneyBillWave />

          </div>


          <input
            type="number"
            inputMode="numeric"
            placeholder="0"
            value={amount}
            onChange={
              handleAmountChange
            }
            min={
              selectedCountry
                ? minimumAmount
                : undefined
            }
            max={
              MAX_AMOUNT
            }
            aria-label="Deposit amount"
          />


          <div
            className="bfc-currency"
          >

            {currency || "---"}

          </div>

        </div>


        {/* =================================================
            RANGE
        ================================================= */}

        <div
          className="bfc-deposit-range"
        >

          <div
            className="bfc-range-line"
          >

            <span />

          </div>


          <div
            className="bfc-range-text"
          >

            {selectedCountry

              ? `${minimumAmount.toLocaleString(
                  "en-US"
                )} - ${MAX_AMOUNT.toLocaleString(
                  "en-US"
                )} ${currency}`

              : "Select country first"}

          </div>

        </div>


        {/* =================================================
            ENTERED AMOUNT
        ================================================= */}

        <div
          className="bfc-entered-amount"
        >

          <span>
            Deposit Amount
          </span>


          <strong>

            {selectedCountry

              ? `${formattedAmount} ${currency}`

              : "--"}

          </strong>

        </div>


        {/* =================================================
            EXCHANGE RATE
        ================================================= */}

        <div
          className="bfc-exchange-rate-box"
        >

          <div
            className="bfc-exchange-icon"
          >

            <FaExchangeAlt />

          </div>


          <div
            className="bfc-exchange-content"
          >

            <span>
              EXCHANGE RATE
            </span>


            <strong>

              {selectedCountry

                ? `1 USDT = ${exchangeRate.toLocaleString(
                    "en-US"
                  )} ${currency}`

                : "Select country first"}

            </strong>

          </div>

        </div>


        {/* =================================================
            RECEIVE
        ================================================= */}

        <div
          className="bfc-usdt-receive-box"
        >

          <div
            className="bfc-usdt-icon"
          >

            <FaCoins />

          </div>


          <div
            className="bfc-usdt-content"
          >

            <span>
              YOU WILL RECEIVE
            </span>


            <strong>

              {selectedCountry

                ? `${formattedMobileUsdt} USDT`

                : "--"}

            </strong>

          </div>

        </div>

      </div>


      {/* =================================================
          MOBILE MONEY PROVIDER
      ================================================= */}

      <div
        className={`bfc-provider-box ${
          showHint
            ? "shake"
            : ""
        }`}
        onClick={() => {

          if (
            !selectedCountry
          ) {

            showBanner(
              "Please select country"
            );


            setShowCountry(
              true
            );


            return;

          }


          setShowProviders(
            !showProviders
          );


          setShowHint(
            false
          );

        }}
      >

        <div
          className="bfc-provider-content"
        >

          <div
            className="bfc-provider-icon"
          >

            <FaMobileAlt />

          </div>


          <div>

            <span
              className="bfc-provider-label"
            >

              MOBILE MONEY

            </span>


            <h3>

              {provider ||
                "Select Mobile Money"}

            </h3>


            <p>

              Choose where you will
              send your deposit

            </p>

          </div>

        </div>


        <FaChevronDown
          className={
            showProviders
              ? "bfc-chevron-open"
              : ""
          }
        />

      </div>


      {/* =================================================
          PROVIDER HINT
      ================================================= */}

      {showHint &&
        showProviders && (

          <div
            className="bfc-select-hint"
          >

            Please select a Mobile
            Money provider

          </div>

        )}


      {/* =================================================
          PROVIDER LIST
      ================================================= */}

      {showProviders && (

        <div
          className="bfc-method-list"
        >

          {mobileMethods.length >
          0

            ? (

              mobileMethods.map(
                (
                  item,
                  index
                ) => (

                  <button
                    type="button"
                    key={
                      index
                    }
                    className={`bfc-method-item ${
                      provider ===
                      item
                        ? "selected-method"
                        : ""
                    }`}
                    onClick={(
                      e
                    ) => {

                      e.stopPropagation();


                      selectProvider(
                        item
                      );

                    }}
                  >

                    <div
                      className="bfc-method-left"
                    >

                      <div
                        className="bfc-method-icon"
                      >

                        <FaMobileAlt />

                      </div>


                      <div
                        className="bfc-method-info"
                      >

                        <span>
                          {item}
                        </span>


                        <small>

                          {
                            selectedCountry?.name
                          }{" "}

                          Mobile Money

                        </small>

                      </div>

                    </div>


                    {provider ===
                      item && (

                      <FaCheckCircle
                        className="bfc-method-check"
                      />

                    )}

                  </button>

                )
              )

            )

            : (

              <div
                className="bfc-no-method"
              >

                No Mobile Money
                provider available
                for this country.

              </div>

            )}

        </div>

      )}


      {/* =================================================
          INFO BOX
      ================================================= */}

      <div
        className="bfc-info-box"
      >


        <div
          className="bfc-info-item"
        >

          <span
            className="bfc-info-label"
          >

            <FaCheckCircle />

            Fee

          </span>


          <strong
            className="success"
          >

            0%

          </strong>

        </div>


        <div
          className="bfc-info-item"
        >

          <span
            className="bfc-info-label"
          >

            <FaClock />

            Processing

          </span>


          <strong
            className="processing"
          >

            Instant

          </strong>

        </div>


        <div
          className="bfc-info-item"
        >

          <span
            className="bfc-info-label"
          >

            <FaWallet />

            Receive

          </span>


          <strong>

            {selectedCountry

              ? `${formattedMobileUsdt} USDT`

              : "--"}

          </strong>

        </div>

      </div>


      {/* =================================================
          SECURITY
      ================================================= */}

      <div
        className="bfc-security-note"
      >

        <div
          className="bfc-security-icon"
        >

          <FaShieldAlt />

        </div>


        <div>

          <strong>
            Secure BFC Deposit
          </strong>


          <p>

            {selectedCountry

              ? `Send the exact ${currency} amount using your selected Mobile Money provider.`

              : "Select your deposit country first."}

          </p>

        </div>

      </div>


      {/* =================================================
          CONTINUE
      ================================================= */}

      <button
        type="button"
        className="bfc-deposit-btn"
        onClick={
          handleDeposit
        }
      >

        <span>
          Continue Deposit
        </span>


        <FaArrowLeft
          className="bfc-button-arrow"
        />

      </button>


      {/* =================================================
          COUNTRY MODAL
      ================================================= */}

      {showCountry && (

        <div
          className="bfc-country-modal-overlay"
          onClick={
            closeCountrySelector
          }
        >

          <div
            className="bfc-country-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >


            {/* =============================================
                MODAL HEADER
            ============================================= */}

            <div
              className="bfc-country-modal-header"
            >

              <button
                type="button"
                className="bfc-country-modal-back"
                onClick={
                  closeCountrySelector
                }
              >

                <FaArrowLeft />

              </button>


              <div>

                <strong>
                  Select Country
                </strong>


                <span>
                  BFC Mobile Money
                </span>

              </div>


              <button
                type="button"
                className="bfc-country-modal-close"
                onClick={
                  closeCountrySelector
                }
              >

                <FaTimes />

              </button>

            </div>


            {/* =============================================
                SEARCH
            ============================================= */}

            <div
              className="bfc-country-search"
            >

              <FaSearch />


              <input
                type="text"
                placeholder="Search country or currency..."
                value={
                  countrySearch
                }
                onChange={(e) =>
                  setCountrySearch(
                    e.target.value
                  )
                }
                autoComplete="off"
              />


              {countrySearch && (

                <button
                  type="button"
                  onClick={() =>
                    setCountrySearch(
                      ""
                    )
                  }
                  aria-label="Clear search"
                >

                  <FaTimes />

                </button>

              )}

            </div>


            {/* =============================================
                COUNTRY LIST
            ============================================= */}

            <div
              className="bfc-country-list"
            >

              {filteredCountries.length >
              0

                ? (

                  filteredCountries.map(
                    (
                      country
                    ) => {

                      const active =
                        selectedCountry?.name ===
                        country.name;


                      return (

                        <button
                          type="button"
                          key={
                            country.name
                          }
                          className={`bfc-country-item ${
                            active
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            handleCountrySelect(
                              country
                            )
                          }
                        >

                          <div
                            className="bfc-country-item-left"
                          >

                            <div
                              className="bfc-country-item-flag"
                            >

                              {
                                country.flag
                              }

                            </div>


                            <div
                              className="bfc-country-item-info"
                            >

                              <strong>

                                {
                                  country.name
                                }

                              </strong>


                              <span>

                                {
                                  country.currency
                                }

                              </span>


                              <small>

                                1 USDT ={" "}

                                {Number(
                                  country.rate
                                ).toLocaleString(
                                  "en-US"
                                )}{" "}

                                {
                                  country.currency
                                }

                              </small>

                            </div>

                          </div>


                          {active && (

                            <FaCheckCircle
                              className="bfc-country-check"
                            />

                          )}

                        </button>

                      );

                    }
                  )

                )

                : (

                  <div
                    className="bfc-country-empty"
                  >

                    <FaSearch />


                    <strong>
                      No country found
                    </strong>


                    <span>
                      Try another country
                      or currency.
                    </span>

                  </div>

                )}

            </div>


            {/* =============================================
                FOOTER
            ============================================= */}

            <div
              className="bfc-country-modal-footer"
            >

              <span>

                {
                  filteredCountries.length
                }{" "}

                countries available

              </span>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}